/** @format */

import { useCallback, useState } from "react";
import { getPlanningAll } from "services/v2/planningservice";
import { getLaporanErkam } from "services/v2/planningservice/laporanservices";
import { getLaporanPengembalianDanaAxios } from "services/v2/reportservice";

export const useLaporanMadrasahPengajuanBos = (
  dataMadrasah: any,
  auth: any,
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [nilaiPortalBos, setNilaiPortalBos] = useState<any>(null);
  const [nilaiRencanaPendapatan, setNilaiRencanaPendapatan] =
    useState<any>(null);
  const [dataLaporanErkam, setDataLaporanErkam] = useState<any>([]);
  const [nilaiPengembalianDana, setNilaiPengembalianDana] = useState<any>(null);

  const getDataBosMadrasah = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        nsm: dataMadrasah?.nsmMadrasah,
        tahun: auth?.isTahun,
      };
      const [
        tmpNilaiPortalBos,
        tmpNilaiRencanaPendapatan,
        tmpLaporanErkam,
        tmpNilaiPengambalianDana,
      ] = await Promise.all([
        getPlanningAll("portal-bos", params),
        getPlanningAll("rencana-pendapatan-by-nsm", params),
        getLaporanErkam({
          tahun: auth?.isTahun,
          madrasahId: dataMadrasah?.madrasahId,
        }),
        getLaporanPengembalianDanaAxios(
          auth?.isTahun - 1,
          auth,
          dataMadrasah?.madrasahId,
        ),
      ]);
      setNilaiRencanaPendapatan(tmpNilaiRencanaPendapatan);
      setNilaiPortalBos(tmpNilaiPortalBos);
      setDataLaporanErkam(tmpLaporanErkam);
      setNilaiPengembalianDana(tmpNilaiPengambalianDana || { sisa: 0 });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMadrasah?.madrasahId, dataMadrasah?.nsmMadrasah, auth?.isTahun]);

  return {
    loading,
    nilaiPortalBos,
    nilaiRencanaPendapatan,
    dataLaporanErkam,
    nilaiPengembalianDana,
    getDataBosMadrasah,
  };
};
